import EventToHistoryContainer from "./EventToHistoryContainer";

export default EventToHistoryContainer;
